import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class LogAzioniService {

  private http = inject(HttpClient);
  logAzioniUrl = environment.ildatoArticoliDpi + 'api/logazioni';

  list(daData: Date | null = null,
    aData: Date | null = null): Observable<any[]> {
    let filter = '';
    if (daData != null) {
      filter += 'DaData=' + daData.toJSON() + '&';
    }
    if (aData != null) {
      filter += 'AData=' + aData.toJSON() + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<any[]>(this.logAzioniUrl + '/list' + filter);
  }
}
